import React, { useContext, useState } from 'react';
import { Col, DropdownMenu, Row, Calendar, DateInput, TextDisplay } from '@paypalcorp/pp-react';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import styles from './VaultSetupTokenConfigurator.module.less';
import DebouncedTextInput from '../../../components/DebouncedTextInput';
import ShippingAddressForm from './VaultSetupShippingAddressForm';
import OneTimeChargesForm from './OneTimeChargesForm';
import { pricingModelLabelMap } from './constants';

const VaultSetupTokenConfigurator = () => {
  const [isCalendarVisible, showCalendar] = useState(false);

  const {
    VaultSetupTokenConfigurator: {
      name,
      usagePattern,
      selectedUsagePattern,
      selectedFrequency,
      updateVaultSetupOption,
      frequency,
      startDate,
      intervalCount,
      totalCycles
    }
  } = useContext(IntegrationPageSectionContext);

  const handleDropdownChange = (event, key) => {
    updateVaultSetupOption(event.target.value, key);
  };

  const handleDateChange = (date) => {
    updateVaultSetupOption(date, 'startDate');
    showCalendar(false);
  };

  return (
    <div className={styles.vault_configurator_container}>
      <Row>
        <Col>
          <DebouncedTextInput
            className={styles.customization_field}
            label="Your plan's name"
            initialValue={name}
            type="text"
            onChange={(value) => updateVaultSetupOption(value, 'name')}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <DropdownMenu
            className={styles.customization_field}
            id="simple"
            label="Select a usage pattern"
            options={usagePattern.options}
            value={selectedUsagePattern}
            onChange={(e) => handleDropdownChange(e, 'selectedUsagePattern')}
            onClose={() => {}}
          />
        </Col>
        <Col>
          <TextDisplay label="Pricing Model" value={pricingModelLabelMap[selectedUsagePattern]} />
        </Col>
      </Row>
      <Row>
        <Col>
          <DropdownMenu
            className={styles.customization_field}
            id="simple"
            label="Select the frequency for your plan"
            options={frequency?.options}
            value={selectedFrequency}
            onChange={(e) => handleDropdownChange(e, 'selectedFrequency')}
            onClose={() => {}}
          />
        </Col>
        <Col>
          <DebouncedTextInput
            className={styles.customization_field}
            label="Duration of the billing cycle"
            initialValue={intervalCount}
            type="number"
            onChange={(value) => {
              updateVaultSetupOption(value, 'intervalCount');
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <DebouncedTextInput
            className={styles.customization_field}
            label="Total cycles"
            initialValue={totalCycles}
            type="number"
            onChange={(value) => {
              updateVaultSetupOption(value, 'totalCycles');
            }}
          />
        </Col>
        <Col>
          <DateInput
            name="dateSelector"
            label="Start Date"
            calendar={
              <Calendar
                selectedDate={startDate}
                onSelection={handleDateChange}
                calendarFrom={new Date()}
              />
            }
            selectedDate={startDate}
            onSelection={handleDateChange}
            isCalendarVisible={isCalendarVisible}
            onShowCalendar={showCalendar}
          />
        </Col>
      </Row>
      <OneTimeChargesForm />
      <ShippingAddressForm />
    </div>
  );
};

export default VaultSetupTokenConfigurator;
